import Vue from 'vue'
import App from './App.vue'

import router from './router'
import vuex from './vuex'
import axios from './axios'
import errorHandling from './errorHandling.js'

import moment from 'moment'
import clone from 'clone'

import 'babel-polyfill'

// import './vuetify'
import vuetify from './plugins/vuetify';

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

import VueSuglify from "vue-suglify";

Vue.component("suglify", VueSuglify);

import VueDragscroll from 'vue-dragscroll';
Vue.use(VueDragscroll);

import Scrollspy from 'vue2-scrollspy';
// use default options
Vue.use(Scrollspy);

// or custom options
// Vue.use(Scrollspy, options);

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$clone = clone;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E',
    libraries: 'places',
  },
  installComponents: true,
});

// try i18n translations
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import juvo from '../juvo-console.json';
import '@babel/polyfill'

const i18n = new VueI18n({
  locale: 'ro', // set locale
  messages: juvo, // set locale messages
})

new Vue({
  i18n,
  router,
  vuetify,
  store: vuex,
  render: h => h(App)
}).$mount('#app');
